import React, {useEffect} from "react";
import css from './block1NewsPanel.module.scss';
import {observer} from "mobx-react";
import {makeAutoObservable, toJS} from "mobx";
import * as Api from "api/api";
import classNames from "classnames";
import useMyStores from "@/hooks/useMyStores";
import MyRouter from "router/router";
import {useHistory} from "react-router-dom";
import NewsMenuType from "enum/NewsMenuType";
import NewsCategoryId from "enum/NewsCategoryId";
import useUserState from "hooks/useUserState.ts";

class NewsStore {
    list = []

    setList(value) {
        this.list = value
    }

    constructor() {
        makeAutoObservable(this)
    }
}

const newsStore = new NewsStore()

function useFetchNewsList({setNewsList}) {

    useEffect(() => {
        Api.homeNewsList({
            pageSize: 15,
            pageNum: 1
        }).then(({list, totalNum}) => {
            setNewsList(list)
        });
    }, []);
}

const Index = ({className}) => {
    const {app: appStore} = useMyStores()
    const userState = useUserState()
    const history = useHistory()

    useFetchNewsList({setNewsList: v => newsStore.setList(v)})

    const toLogin = () => {
        history.replace({
            pathname: MyRouter.Login.path
        });
    }

    const toAddShop = () => {
        window.open(`${MyRouter.basename}${MyRouter.Merchant.path}`);
    }

    const toUserInfo = () => {
        window.open(MyRouter.basename + MyRouter.User.path);
    }

    const toMoreNotice = () => {
        history.push({
            pathname: `${MyRouter.News.realPath}`,
            search: `menuType=${NewsMenuType.NEWS}&categoryId=${NewsCategoryId.NOTICE}`,
        })
    }

    const toNoticeInfo = (id) => {
        window.open(
            `${MyRouter.basename}${MyRouter.News.realPath}/${id}?menuType=${NewsMenuType.NEWS}&categoryId=${NewsCategoryId.NOTICE}`
        );
    }

    return (
        <div className={classNames("news-panel", className, css.root)}>
            <div className={css.top}>
                <div className={css.left}>
                    <div className={css.avatarWrapper}>
                        <img className={css.avatar} alt='' src={userState.userInfo.avatar}/>
                    </div>
                </div>
                <div className={css.right}>
                    <div className={css.textFloor1}>
                        欢迎来到
                    </div>
                    <div className={css.textFloor2}>
                        {appStore.app?.websiteName}
                    </div>
                    <div className={css.btnFloor}>
                        {
                            !userState.isLogin &&
                            <>
                                <button className={css.btnLogin} onClick={toLogin}>登录</button>
                                <button className={css.btnAddShop} onClick={toAddShop}>开店</button>
                            </>
                        }
                        {
                            userState.isLogin &&
                            <div className={css.btnUsername} onClick={toUserInfo}>
                                {`用户${userState.userInfo.nickname || userState.userInfo.username}`}
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div className={css.bottom}>
                <div className={css.titleFloor}>
                    <div className={css.titleFloorContainer}>
                        <div className={css.titleWrapper}>
                            <span>公告</span>
                        </div>
                        <div className={css.moreContainer}>
                            <div className={css.moreWrapper} onClick={toMoreNotice}>
                                <span>更多</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={css.itemList}>
                    {
                        newsStore.list.slice(0, 7).map(item => {
                            const {id, title} = item
                            return (
                                <div key={id} className={css.item} onClick={() => {
                                    toNoticeInfo(id)
                                }}>
                                    <span>{title}</span>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default observer(Index)